module.exports = __webpack_public_path__ + "static/media/eng_d_2323.f71fb7a3.mp4";